import React from "react";
import { Box, Typography } from "@mui/material";

interface ImageBoxProps {
    imageUrl?: string;
    altText?: string;
    fallbackText?: string;
    width?: string | number;
    height?: string | number;
}

const ImageBox: React.FC<ImageBoxProps> = ({
    imageUrl,
    altText = "Image",
    fallbackText = "No Image",
    width = "150px",
    height = "150px",
}) => {
    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: width,
                height,
                border: "1px solid #ccc",
                borderRadius: "8px",
                overflow: "hidden",
                marginBottom: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: !imageUrl ? "secondary.main" : "transparent",
                transition: "background-color 0.2s ease-in-out",
                "&:hover": {
                    backgroundColor: !imageUrl ? "secondary.main" : "transparent",
                },
            }}
        >
            {imageUrl ? (
                <img
                    src={imageUrl}
                    alt={altText}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                />
            ) : (
                    <Typography variant="body2" color="white" sx={{ textAlign: "center", width: "100%" }}>
                    {fallbackText}
                </Typography>
            )}
        </Box>
    );
};

export default ImageBox;
